import { createFileRoute, redirect } from '@tanstack/react-router';

// Moved to the Integrations section; kept so old links still land.
export const Route = createFileRoute(
  '/_auth/_side-layout/settings_/integrations',
)({
  beforeLoad: () => {
    throw redirect({ to: '/integrations/access/mcp' });
  },
});
